import { render, staticRenderFns } from "./PlaywireAdController.vue?vue&type=template&id=9bc1e358&lang=pug&"
import script from "./PlaywireAdController.vue?vue&type=script&lang=js&"
export * from "./PlaywireAdController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports